import {
  PrivateBankingServiceDefinitionId,
  type PrivateBankingServiceDefinitionId as PrivateBankingServiceDefinitionIdValue,
} from 'pco-product-service-internal-consumer';

type MaybePrivateBankingServiceDefinitionId = PrivateBankingServiceDefinitionIdValue | undefined;

export const isEBankingServiceDefinitionId = (serviceDefinitionId: MaybePrivateBankingServiceDefinitionId) =>
  serviceDefinitionId === PrivateBankingServiceDefinitionId.Ebanking;

export const isDebitMaestrocardServiceDefinitionId = (serviceDefinitionId: MaybePrivateBankingServiceDefinitionId) =>
  serviceDefinitionId === PrivateBankingServiceDefinitionId.DebitMaestrocard;

export const isSafeDepositBoxServiceDefinitionId = (serviceDefinitionId: MaybePrivateBankingServiceDefinitionId) =>
  serviceDefinitionId === PrivateBankingServiceDefinitionId.SafeDepositBox;

export const isInvestmentProductServiceDefinitionId = (serviceDefinitionId: MaybePrivateBankingServiceDefinitionId) =>
  serviceDefinitionId === PrivateBankingServiceDefinitionId.ServiceModel;

export const isSafeClearingServiceDefinitionId = (serviceDefinitionId: MaybePrivateBankingServiceDefinitionId) =>
  serviceDefinitionId === PrivateBankingServiceDefinitionId.SafeClearing;

export const isWealthPlanningServiceDefinitionId = (serviceDefinitionId: MaybePrivateBankingServiceDefinitionId) =>
  serviceDefinitionId === PrivateBankingServiceDefinitionId.WealthPlanningServices;

export const isActiveReferralWpServiceDefinitionId = (serviceDefinitionId: MaybePrivateBankingServiceDefinitionId) =>
  serviceDefinitionId === PrivateBankingServiceDefinitionId.ActiveReferralWp;

export const isActiveReferralRmServiceDefinitionId = (serviceDefinitionId: MaybePrivateBankingServiceDefinitionId) =>
  serviceDefinitionId === PrivateBankingServiceDefinitionId.ActiveReferralRm;

export const isActiveReferralServiceDefinitionId = (serviceDefinitionId: MaybePrivateBankingServiceDefinitionId) =>
  isActiveReferralWpServiceDefinitionId(serviceDefinitionId) ||
  isActiveReferralRmServiceDefinitionId(serviceDefinitionId);

/** Products configured through service roles / partner selection (E-Banking-style editable UX). */
export const hasServiceRoleConfiguration = (serviceDefinitionId: MaybePrivateBankingServiceDefinitionId) =>
  isEBankingServiceDefinitionId(serviceDefinitionId) || isDebitMaestrocardServiceDefinitionId(serviceDefinitionId);

export const hasEditableServiceRoleConfiguration = (serviceDefinitionId: MaybePrivateBankingServiceDefinitionId) =>
  hasServiceRoleConfiguration(serviceDefinitionId) || isSafeDepositBoxServiceDefinitionId(serviceDefinitionId);

export const showsServiceRoleUsersTable = (serviceDefinitionId: MaybePrivateBankingServiceDefinitionId) =>
  hasEditableServiceRoleConfiguration(serviceDefinitionId);
